// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"2cd89f06","57":"4feb3abf","70":"1eed4b07","97":"570e44f4","161":"54b503dc","176":"10dddde5","243":"b2ef4902","359":"8bd242ba","365":"a3396839","375":"a52cf3d8","471":"413fc7ef","580":"7b0a6e23","746":"c2ae0bea","855":"62531142","879":"128b168b","944":"8dab7f2f"}[chunkId] + ".chunk.js";
};